export default __webpack_public_path__ + "static/media/s4.f8b012db.jpg";